import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column', 
    color: '#fff',
    width: '66.66%',
    margin: 'auto 30px',
    fontSize: '12px',
    fontWeight: '600',
    textDecoration: 'underline'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  link: {
    cursor: 'pointer',
    margin: '10px',
    width: '18%',
    transition: 'color 0.3s',
    '&:hover': {
      color: 'blue',
    },
    '&::before': {
      content: '•',
      marginRight: '5px',
    },
  },
});

const FooterLinks = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.row}>
        <p className={classes.link} onClick={() => console.log('Redirect to Home')}> • Home</p>
        <p className={classes.link} onClick={() => console.log('Redirect to Important Links')}> • Important Link</p>
        <p className={classes.link} onClick={() => console.log('Redirect to Disclaimer')}> • Disclaimer</p>
        <p className={classes.link} onClick={() => console.log('Redirect to Privacy Policy')}> • Privacy Policy</p>
      </div>
      <div className={classes.row}>
        <p className={classes.link} onClick={() => console.log('Redirect to Terms and Conditions')}> • Terms and Conditions</p>
        <a href="content/faq" className={classes.link}> • FAQ</a>
        <p className={classes.link} onClick={() => console.log('Redirect to Feedback & Complaint')}> • Feedback & Complaint</p>
        <p className={classes.link} onClick={() => console.log('Redirect to E-Samadhan')}> • E-Samadhan</p>
      </div>
    </div>
  );
};

export default FooterLinks;
